module.exports = __webpack_public_path__ + "static/img/k.3c6602c4.png";